import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <div className='main-container-footer'>
            {/* --- TOP SECTION: 3 Columns --- */}
            <div className='footer-top-section'>

                {/* Column 1: Find Us & Follow Us */}
                <div className='footer-col footer-col-1'>
                    <div className='footer-heading-wrapper'>
                        <svg className="footer-header-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        <h2>Find Us</h2>
                    </div>
                    <p className='footer-subheading'>Visit our campus</p>

                    <div className='footer-map-wrapper'>
                        <iframe
                            title="TIMSCDR Location Map"
                            src="https://maps.google.com/maps?q=TIMSCDR%20-%20Thakur%20Institute%20of%20Management%20Studies,%20Career%20Development%20&%20Research&t=&z=14&ie=UTF8&iwloc=&output=embed"
                            width="100%"
                            height="240"
                            style={{ border: 0, borderRadius: '12px' }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                    <div className='footer-map-address'>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        <span>Thakur Educational Campus, Kandivali (E), Mumbai – 400 101.</span>
                    </div>


                </div>

                {/* Column 2: Contact Us */}
                <div className='footer-col footer-col-2'>
                    <div className='footer-heading-wrapper'>
                        <svg className="footer-header-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                        </svg>
                        <h2>Contact Us</h2>
                    </div>
                    {/* <p className='footer-subheading'>We're here to help</p> */}

                    <div className='contact-items-wrapper'>
                        <div className='contact-item'>
                            <div className='contact-icon-circle'>
                                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" /></svg>
                            </div>
                            <div className='contact-text'>
                                <h3>Phone</h3>
                                <a href="tel:+919594965066">+91 - 95949 65066</a>
                                <a href="tel:02267308301">022 - 67308301/02</a>
                                <a href="tel:02267308301">022 - 67308301/02</a>
                                <a href="tel:02228840484">022 - 28840484/91</a>

                            </div>
                        </div>

                        <div className='contact-item'>
                            <div className='contact-icon-circle'>
                                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" /></svg>
                            </div>
                            <div className='contact-text'>
                                <h3>Email</h3>
                                <a href="mailto:TIMSCDR@thakureducation.org">timscdr@thakureducation.org</a>
                            </div>
                        </div>

                        <div className='contact-item'>
                            <div className='contact-icon-circle'>
                                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" /></svg>
                            </div>
                            <div className='contact-text'>
                                <h3>Address</h3>
                                <p>Thakur Institute of Management Studies, Career Development & Research,<br />Thakur Educational Campus, Shyamnarayan Thakur Marg, Thakur Village,<br />Kandivali (E), Mumbai – 400 101.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Column 3: Quick Links */}
                <div className='footer-col footer-col-3'>
                    <div className='footer-heading-wrapper'>
                        <svg className="footer-header-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                        </svg>
                        <h2>Quick Links</h2>
                    </div>
                    <p className='footer-subheading'>Explore important resources</p>

                    <div className='quick-links-list'>
                        <a href='https://www.aicte.gov.in/feedback/index.php'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> AICTE Feedback</a>
                        <a href='/womens-grievance-redressal-committee'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> Women’s Grievance Redressal Committee</a>
                        <a href='/Class-Improvement-MCA'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> Class Improvement MCA</a>
                        <a href='https://mu.ac.in/'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> University of Mumbai</a>
                        <a href='/downloads'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> Downloads</a>
                        <a href='/feedback'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> Feedback</a>
                        <a href='/college-grievance-redressal-committee/'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> Grievance Redressal Committee</a>
                        <a href='/mandatory-disclosure'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> Mandatory Disclosure</a>
                        <a href='/RTI'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> RTI</a>
                        <a href='/blogs'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> Blogs</a>
                        <a href='https://www.aicte.gov.in/'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> AICTE</a>
                        <a href='/content-policy'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> Content Policy</a>
                        <a href='/disclaimer'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg> Disclaimer</a>
                    </div>
                </div>
            </div>

            {/* --- BOTTOM SECTION: Copyright & Links --- */}
            <div className='bottom-footer'>
                <div className='bottom-footer-left'>
                    <p className='bottom-footer-text'>
                        Copyright © 2026 Thakur Institute of Management Studies, Career Development & Research<br />
                        <span style={{ fontSize: '11px' }}>(An Institute under Thakur Educational Trust)</span>
                    </p>
                </div>
                <div className='bottom-footer-right'>
                    {/* <a href="/privacy-policy">Privacy Policy</a> */}
                    {/* <span className="footer-divider">|</span> */}
                    <a href="/disclaimer">Disclaimer</a>
                    <span className="footer-divider">|</span>
                    <span className='bottom-footer-developed-by'>Developed by TEG Marketing Team</span>
                </div>
            </div>
        </div>
    )
}

export default Footer;